import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the CapiumPay invite popup still reads from the workspace: the open row and draft the client row menu sets, the directory list and its loader refreshed after a send, and the shared surface click handler.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsCapiumPayInviteHost = Pick<
  PmWorkspaceComponent,
  | 'activeDropdown'
  | 'clientsCapiumPayActiveDropdown'
  | 'clientsCapiumPayCountries'
  | 'clientsCapiumPayInviteDraft'
  | 'clientsCapiumPayInviteModalOpen'
  | 'clientsCapiumPayInviteRow'
  | 'clientsCapiumPayInviteSaving'
  | 'clientsDirectoryPageNumber'
  | 'closeClientsCapiumPayInviteModal'
  | 'directoryClientsCache'
  | 'effectiveDirectoryParentUserId'
  | 'loadDirectoryClientsPage'
  | 'onClientsAddModalSurfaceClick'
>;

export const PM_CLIENTS_CAPIUM_PAY_INVITE_HOST = new InjectionToken<PmClientsCapiumPayInviteHost>('PmClientsCapiumPayInviteHost');
